/* eslint-disable css-modules/no-unused-class  */
import { useEffect, useState, FC } from 'react';
import { useSelector } from 'react-redux';
import { getPlatformUrl } from 'utils';
import { FullPageLoader } from 'learning-panel-components';
import { selectIsLeanUser, selectUserUuid } from '@redux/slices/userSlice';
import { useGetPrimaryCourseData } from '@queries/platform/userContent';
import PrimaryCourse from './primaryCourse';

const PrimaryCourseContainer: FC<{ onChangePrimaryCourse: Function; setIsPrimaryCourseDialogOpen: Function }> = ({
    onChangePrimaryCourse,
    setIsPrimaryCourseDialogOpen
}: {
    onChangePrimaryCourse: Function;
    setIsPrimaryCourseDialogOpen: Function;
}) => {
    const userUuid = useSelector(selectUserUuid);
    const isLeanUser = useSelector(selectIsLeanUser);
    const [primaryCourse, setPrimaryCourse] = useState<any>(null);

    const { data: primaryCourseData, isLoading } = useGetPrimaryCourseData(userUuid);

    useEffect(() => {
        if (!primaryCourseData?.data) return;

        if (Object.keys(primaryCourseData.data).length === 0) {
            setIsPrimaryCourseDialogOpen(true);
            return;
        }

        const { course, lessons } = primaryCourseData.data;
        const primaryCourseTmp = {
            course: {
                uuid: course.uuid,
                displayName: course.display_name,
                completionPercentage: course.completion_percentage,
                score: course.score,
                iconUrl: course.icon_url ?? `${process.env.PUBLIC_URL}/images/courseDefaultCard.svg`,
                totalLessons: course.total_lessons,
                completedLessons: course.completed_lessons
            },
            lessons: lessons.map((lesson: any) => {
                return {
                    uuid: lesson.uuid,
                    lessonDisplayName: lesson.display_name,
                    lessonStatus: lesson.status,
                    lessonUrl: lesson.url,
                    activeOnLean: lesson.active_on_lean
                };
            })
        };
        setPrimaryCourse(primaryCourseTmp);
    }, [primaryCourseData]);

    return isLoading || primaryCourse === null ? (
        <FullPageLoader />
    ) : (
        <PrimaryCourse
            courseName={primaryCourse?.course?.displayName}
            courseUrl={`${getPlatformUrl()}/app/course?courseUuid=${primaryCourse?.course?.uuid}`}
            courseLessons={primaryCourse?.lessons || []}
            isLoading={isLoading}
            onChangePrimaryCourse={() => onChangePrimaryCourse(true)}
            score={primaryCourse?.course?.score}
            iconUrl={primaryCourse?.course?.iconUrl}
            completionPercentage={primaryCourse?.course?.completionPercentage}
            totalLessons={primaryCourse?.course?.totalLessons}
            competedLessons={primaryCourse?.course?.completedLessons}
            isLeanUser={isLeanUser}
        ></PrimaryCourse>
    );
};

export default PrimaryCourseContainer;
